import service from "./goartRequest";
/**
 * 获取区块链信息
 * @param sn 藏品编号 示例:"PB%23PRZZP@50/100"
 * @param uid 分享人uid
 * @returns 
 */
export function getBlockInfo(sn: string) {
  return service({
    url: "/api/nft-sale/dc/goods/web/block",
    method: "get",
    params: {
      sn
    }
  });
}

/**
 * 已购买藏品分享
 * @param sn 藏品编号 示例:"PB%23PRZZP@50/100"
 * @param uid 分享人uid
 * @returns 
 */
export function getDigitalCollectionInfo(sn: string) {
  return service({
    url: "/api/nft-sale/dc/goods/web/user/detail",
    method: "get",
    params: {
      sn
    }
  });
}

//售卖的藏品分享
export function getDigitalCollectionProduct(goodsId: string) {
  return service.get('/api/nft-sale/dc/goods/detail', {
    params: {
      goodsId
    }
  })
}
//获取某藏品的全系列藏品
export function get_all_series_collection_list(itemId: string, page: number, pageSize: number) {
  return service({
    url: `/api/nft-sale/dc/goods/sn-personalizations`,
    method: "get",
    params: {
      itemId,
      page,
      pageSize,
    }
  });
}

//获取用户分享的藏品列表
export function get_user_digital_collection_list(uid: string, page: number, pageSize: number) {
  return service({
    url: `/api/nft-sale/dc/goods/web/user/list`,
    method: "get",
    params: {
      uid,
      page,
      pageSize,
    }
  });
}

/**
 * GoArt 兑换会员
 * @param token token
 * @returns 
 */
export function goartExchangeVip(token: string, code: string) {
  return service({
    url: "/api/goart/app/payment/exchange",
    method: "post",
    data: {
      code
    },
    headers: {
      Authorization: 'bearer ' + token
    },
  });
}




// 盲盒邀请活动-抽奖
export function invite_blind_box_lucky_draw(activityId: string, token: string) {
  return service({
    url: `/api/nft-sale/dc/activity/lucky`,
    method: "get",
    params: {
      activityId,
    },
    headers: {
      Authorization: 'bearer ' + token
    },
  });
}

//获取盲盒邀请活动-抽奖相关信息
export function get_invite_blind_lucky_draw_info(activityId: string, token: string) {
  return service({
    url: `/api/general-activity/user-reward?activityId=${activityId}`,
    method: "get",
    params: {
      activityId,
    },
    headers: {
      Authorization: 'bearer ' + token
    },
  });
}

//获取盲盒邀请活动信息
export function get_invite_blind_box_info(activityId: string, token: string) {
  return service({
    url: `/api/nft-sale/dc/activity/${activityId}`,
    method: "get",
    headers: {
      Authorization: 'bearer ' + token
    },
  });
}
//获取盲盒邀请活动，已邀请用户列表
export function get_invite_blind_invited_friends(activityId: string, pageNum: number, pageSize: number, token: string) {
  return service({
    url: `/api/nft-sale/dc/activity/invitation-list`,
    method: "get",
    params: {
      activityId,
      pageNum,
      pageSize
    },
    headers: {
      Authorization: 'bearer ' + token
    },
  });
}

//获取盲盒邀请活动，抽奖记录
export function get_invite_blind_lucky_draw_record(activityId: string, token: string) {
  return service({
    url: `/api/nft-sale/dc/activity/reward-list`,
    method: "get",
    params: {
      activityId,
    },
    headers: {
      Authorization: 'bearer ' + token
    },
  });
}


export function join_invite(uid: string, inviteEmail: string, activityId: string) {

  return service({
    url: `/api/nft-sale/dc/activity`,
    method: "post",
    data: {
      uid,
      inviteEmail,
      activityId,
    },
  });
}
export function get_user_info(uid: string) {

  return service({
    url: `/api/nft-sale/dc/getUserInfo`,
    method: "get",
    params: {
      uid,
    },
  });
}


